module.exports = __webpack_public_path__ + "img/3.8478b5fe.png";